import { render, staticRenderFns } from "./OPPendingComponent.vue?vue&type=template&id=0c074c49&"
import script from "./OPPendingComponent.vue?vue&type=script&lang=js&"
export * from "./OPPendingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports